import React, { useContext } from 'react'
import {dataContext,toText,localestr} from '../utils.js'
import Edit from '../cmp/Edit'
import icon from '../icons.svg'

function ServGrpEdit({data=undefined,actions}){
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData

    const context=useContext(dataContext)
    const getData=context.getData
    const updateData=context.updateData
    const loaddata=context.loaddata
    const msg=context.msg

    const checkAll=(val)=>{
        let list=wndData.list.map(el=>{return {...el,checked:val}})
        setWndData({...wndData,list,checked:val})
    }

    const checkItem=(idx,val)=>{
        let list=[...wndData.list]
        list[idx].checked=val
        setWndData({...wndData,list})
    }

    const checkField=(idx,val)=>{
        let fields=[...wndData.fields]
        fields[idx].checked=val
        setWndData({...wndData,fields})
    }

    const setValue=(idx,val)=>{
        let fields=[...wndData.fields]
        fields[idx].value=val
        setWndData({...wndData,fields})
    }

    const setValueIrg=(idx,val,field)=>{
        let fields=[...wndData.fields]
        fields[idx][field]=val
        setWndData({...wndData,fields})
    }

    const run=(data)=>{
        if(data){
            updateData(data.data.dataType)
            msg(localestr('Зміни успішно виконано'),localestr('Попередження'),[{caption:'OK',action:()=>{}}])
            let list=[...wndData.list||[]]
            if(data.data.value){
                for(let idx=0;idx<list.length;idx++){
                    if(!list[idx].checked) continue
                    data.data.value.forEach(el=>list[idx][el.name]=el.value)
                }
            }
            if(data.data.irg){
                for(let idx=0;idx<list.length;idx++){
                    if(!list[idx].checked) continue
                    const irg=data.data.irg.find(el=>el.id===list[idx].id)
                    if(!irg) continue
                    list[idx].sum=irg.value
                    list[idx].prc=irg.value
                }
            }
        } else {
            let id=[]
            let value=[]
            let irg=[]
            let irg_m=[]
            let irgId=null
            let irgOper=null
            let irgVal=null
            let irgDate=null
            let irgMId=null
            let irgMOper=null
            let irgMVal=null
            let irgMDate=null
            wndData.list.forEach(el => {if(el.checked) id.push(el.id)})
            for(let idx=0;idx<wndData.fields.length;idx++){
                if(wndData.fields[idx].checked){
                    if(wndData.fields[idx].typeVal.substring(0,4)==='irgM'){
                        irgMId=wndData.fields[idx].dataId
                        irgMOper=wndData.fields[idx].method||'~'
                        irgMVal=parseFloat(wndData.fields[idx].value)||0
                        irgMDate=wndData.fields[idx].date||(new Date()).toISOString().substring(0,10)
                    }else if(wndData.fields[idx].typeVal.substring(0,3)==='irg'){
                        irgId=wndData.fields[idx].dataId
                        irgOper=wndData.fields[idx].method||'~'
                        irgVal=parseFloat(wndData.fields[idx].value)||0
                        irgDate=wndData.fields[idx].date||(new Date()).toISOString().substring(0,10)
                    } else value.push({name:wndData.fields[idx].dataId,value:wndData.fields[idx].value||null})
                }
            }
            if(id.length===0){msg(localestr('Немає даних для змін'),localestr('Попередження'),[{caption:'OK',action:()=>{}}]);return}
            if(value.length===0&&irgOper===null&&irgMOper===null){msg(localestr('Немає даних для змін'),localestr('Попередження'),[{caption:'OK',action:()=>{}}]);return}
            if(irgOper==='%') wndData.list.forEach(el => {if(el.checked) irg.push({id:el.id,date:irgDate,value:((parseFloat(el[irgId])||0)*(1+irgVal/100)).toFixed(2)})})
            if(irgOper==='~') wndData.list.forEach(el => {if(el.checked) irg.push({id:el.id,date:irgDate,value:parseInt((parseFloat(el[irgId])||0)*(1+irgVal/100)+0.5).toFixed(2)})})
            if(irgOper==='+') wndData.list.forEach(el => {if(el.checked) irg.push({id:el.id,date:irgDate,value:((parseFloat(el[irgId])||0)+irgVal).toFixed(2)})})
            if(irgOper==='=') wndData.list.forEach(el => {if(el.checked) irg.push({id:el.id,date:irgDate,value:irgVal.toFixed(2)})})
            if(irgMOper==='%') wndData.list.forEach(el => {if(el.checked) irg_m.push({id:el.id,date:irgMDate,value:((parseFloat(el[irgMId])||0)*(1+irgMVal/100)).toFixed(2)})})
            if(irgMOper==='~') wndData.list.forEach(el => {if(el.checked) irg_m.push({id:el.id,date:irgMDate,value:parseInt((parseFloat(el[irgMId])||0)*(1+irgMVal/100)+0.5).toFixed(2)})})
            if(irgMOper==='+') wndData.list.forEach(el => {if(el.checked) irg_m.push({id:el.id,date:irgMDate,value:((parseFloat(el[irgMId])||0)+irgMVal).toFixed(2)})})
            if(irgMOper==='=') wndData.list.forEach(el => {if(el.checked) irg_m.push({id:el.id,date:irgMDate,value:irgMVal.toFixed(2)})})
            const to_send={dataType:wndData.dataType}
            if(value.length!==0) {to_send.id=id;to_send.value=value}
            if(irg.length!==0) to_send.irg=irg
            if(irg_m.length!==0) to_send.irg_m=irg_m
            loaddata('action=grpEdit&data='+JSON.stringify(to_send),undefined,run)
        }
        
    }

    const hItems=wndData.fields.map((col)=>{
        let stl={minWidth:col.minWidth+'px',width:col.minWidth+'px', flexGrow:col.minWidth, flexBasis:col.minWidth+'px'}
        if(col.dataId.substring(0, 3)==='prc'||col.dataId.substring(0, 3)==='sum') stl={minWidth:col.minWidth+'px',width:col.minWidth+'px', flexGrow:col.minWidth, flexBasis:col.minWidth+'px',textAlign:'right'}
        return(<th key={col.dataId} style={stl}>{col.caption} </th>)
        })

    let cnt=0
    const items=wndData.list.map((item,idx)=>{
        if(item.checked) cnt++
        return (
        <tr key={idx}>
            <td key='a' style={{width:'22px',flexShrink:'0'}}><input type='checkbox' checked={item.checked===true} onChange={(e)=>{checkItem(idx,e.target.checked)}} /></td>
            <td key='b' style={{width:'50px',flexShrink:'0'}}>{toText(item.id)}</td>
        {wndData.fields.map((col)=>{
            let stl={minWidth:col.minWidth+'px', flexGrow:col.minWidth, flexBasis:col.minWidth+'px'}
            if(col.dataId.substring(0, 3)==='prc'||col.dataId.substring(0, 3)==='sum') stl={minWidth:col.minWidth+'px', flexGrow:col.minWidth, flexBasis:col.minWidth+'px',textAlign:'right'}
            if (col.maxWidth) stl.maxWidth=col.maxWidth+'px'
            if(col.typeVal&&col.typeVal.substring(0,3)==='sel'){
                const sel=(getData(col.typeVal)||[]).find(el=>el.value===item[col.dataId])
                return (<td key={col.dataId} style={stl}>{toText(sel)}</td>)
            }
            return (<td key={col.dataId} style={stl}>{toText(item[col.dataId])}</td>)
            })}
        </tr>
        )
    })

    const fields=wndData.fields.map((it,idx)=>{
        if(it.dataId==='name') return null
        if(it.typeVal.substring(0,3)==='irg') {
            const d=it.date||(new Date()).toISOString().substring(0,10)
            const m=it.method||'~'
            return(
                <div key={idx} style={{display:'flex',padding:'1px 0',maxWidth:'400px'}}>
                <div style={{width:'22px'}}><input title={localestr('Відмітьте якщо треба змінити і введіть нове значення')} type='checkbox' id={it.typeVal} checked={it.checked===true} onChange={(e)=>{checkField(idx,e.target.checked)}} /></div>
                <div style={{minWidth:'300px',flexGrow:'300',flexBasis:'300px'}}><label title={localestr('Відмітьте якщо треба змінити і введіть нове значення')} for={it.typeVal}>{localestr(it.caption)}</label> 
                <select style={{width:'175px',margin:'0 4px'}} value={m} onChange={(e)=>{setValueIrg(idx,e.target.value,'method')}}  disabled={!it.checked}>
                    <option value='%'>{localestr('змінити на %')}</option>
                    <option value='~'>{localestr('змінити на % і округлити')}</option>
                    <option value='+'>{localestr('Змінити на суму')}</option>
                    <option value='='>{localestr('Фіксоване значення')}</option>
                </select>
                <Edit style={{width:'85px'}} Value={it.value} typeVal={'number'} setVal={(d)=>{setValue(idx,d)}} disabled={!it.checked}/><br />
                встановити на дату
                <Edit style={{width:'110px',margin:'0 4px'}} Value={d} typeVal={'date'} setVal={(d)=>{setValueIrg(idx,d,'date')}} disabled={!it.checked}/>
                </div>
                </div>
            )

            }

        return <div key={idx} style={{display:'flex',padding:'1px 0',maxWidth:'400px'}}>
                <div style={{width:'22px'}}><input title={localestr('Відмітьте якщо треба змінити і введіть нове значення')} id={it.dataId} type='checkbox' checked={it.checked===true} onChange={(e)=>{checkField(idx,e.target.checked)}} /></div>
                <label title={localestr('Відмітьте якщо треба змінити і введіть нове значення')} htmlFor={it.dataId}><div style={{minWidth:'120px',flexGrow:'60',flexBasis:'120px'}}>{localestr(it.caption)}</div></label>
                <div style={{minWidth:'180px',flexGrow:'180',flexBasis:'180px'}}><Edit title={localestr('Нове значення')} Value={it.value} typeVal={it.typeVal} setVal={(d)=>{setValue(idx,d)}} disabled={!it.checked}/></div>
            </div>})


        /*return <tr key={idx} style={{display:'flex',padding:'1px 0'}}>
                <td style={{width:'22px'}}><input type='checkbox' checked={it.checked===true} onChange={(e)=>{checkField(idx,e.target.checked)}} /></td>
                <td style={{minWidth:'120px',flexGrow:'60',flexBasis:'120px'}}>{localestr(it.caption)}</td>
                <td style={{minWidth:'180px',flexGrow:'180',flexBasis:'180px'}}><Edit Value={it.value} typeVal={it.typeVal} setVal={(d)=>{setValue(idx,d)}} disabled={!it.checked}/></td>
            </tr>})*/

    let size=48
    if(wndData.list) size=30+24*wndData.list.length

    return(
        <div style={{display:'flex',flexDirection:'column', width:'100%',height:'100%'}}>
                <div className='toolBar no-print' style={{margin:'0 0 4px 0'}}>
                <div tabIndex='0' onClick={()=>{run()}} onKeyUp={(e)=>{if(e.key === 'Enter') run()}}
                        style={{alignSelf:'center',lineHeight:'30px',height:'30px',width:'97px',padding:'0px 2px 0 6px',color:'#FFF',userSelect:'none',cursor:'pointer',background:'url('+icon+'#btn95v) no-repeat',backgroundSize:'102px 30px'}}>
                        <img style={{width:'12px',height:'24px',padding:'2px',verticalAlign:'middle'}} src={icon+'#run'} alt={localestr('Виконати')} />&nbsp;
                        {localestr('Виконати')}
                    </div>
                    <div style={{lineHeight:'30px',paddingLeft:'10px'}}>{localestr('Відібрано ')+cnt+localestr(' елементів')}</div>
                    <div style={{flexGrow:'10'}}></div>
                </div>
                <div style={{maxHeight:'60%',height:size+'px',minHeight:size>500?'40%':'50px'}}>
                    <table className='valueTable' style={{height:'calc(100% - 3px)',position:'relative'}}><thead><tr>
                        <th style={{width:'22px',flexShrink:'0'}}><input type='checkbox' checked={wndData.checked===true} onChange={(e)=>{checkAll(e.target.checked)}} /></th>
                        <th style={{width:'50px',flexShrink:'0'}}>{localestr('Код')}</th>
                        {hItems}
                    </tr></thead><tbody style={{height:'calc(100% - 27px)',position:'absolute',scrollbarWidth:'none'}}>{items}</tbody></table>
                </div>
                <div style={{display:'flex',flexDirection:'column',flexWrap:'wrap', width:'100%',overflow:'auto'}}>
                    {/*<table style={{overflow:'auto'}}><tbody>{fields}</tbody></table>   */}
                    {fields}                 
                </div>

        </div>

    )
}

export default ServGrpEdit